import { Box, Typography, Card, Button } from '@mui/material'
import { useParams, useNavigate } from 'react-router-dom'

import { ReactComponent as IconCheck } from '../../../icons/check-circle-broken-icon.svg'

function CompleteTransfer() {
  const navigate = useNavigate()
  const { transferWorkspaceId } = useParams()

  return (
    <Box sx={{ maxWidth: '450px', textAlign: 'center' }}>
      <Card sx={{ padding: 3, borderRadius: '12px' }}>
        <IconCheck />
        <Typography variant="h2" color="primary.900">
          All done!
        </Typography>
        <Box sx={{ padding: '12px 0px' }}>
          <Typography variant="body1">Workspace ownership has been transferred successfully.</Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            onClick={() => {
              navigate(`/${transferWorkspaceId}`)
            }}
          >
            Go to dashboard
          </Button>
        </Box>
      </Card>
    </Box>
  )
}

export default CompleteTransfer
